import globals from "./globals";
import $ from "cash-dom";

const layout = (function () {
    /**
     * Initialize Accordion instances
     */
    $(document).ready(function () {
        if ($(".layout-hotspot-image").length) {
            if (globals.debug) console.log("layout-hotspot initialized");
            $(".hotspot").on("mouseover mouseout", function (e) {
                var targetContent = e.type == "mouseover" ? $(e.target).find(".hotspot-description").html() : "";
                // $(".helper").toggleClass("is-visible").find(".helper-inner").html(targetContent);
                $(".hotspot-helper").toggleClass("hidden").find(".hotspot-helper-inner").html(targetContent);
            });
        }
    });
})();

export default layout;
